var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.disabled
        ? [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.desc ? _vm.htmlDesc : "--") },
            }),
          ]
        : _c("yxtbiz-richeditor", {
            ref: "bizRich",
            attrs: {
              content: _vm.htmlDesc,
              "max-length": 2000,
              "org-code": _vm.orgCode,
              "app-code": "kng",
              "function-name": "richeditor",
              "module-name": "knowledge",
              placeholder: _vm.$t(
                "pc_kng_temp_msg_describe_course" /* 请描述课程内容，让你的课程更受欢迎 */
              ),
            },
            on: { change: _vm.change },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }